import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-5xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Privacy Policy
        </h1>

        {/* <p className="text-gray-600 mb-6">Last updated: August 19, 2026</p> */}

        <p className="text-gray-700 leading-7 mb-6">
          This Privacy Policy explains how we collect, use, store, and protect
          information when you use our mobile application and related services.
          By using the application, you agree to the practices described in this
          Privacy Policy.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          1. Information We Collect
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          Depending on the features you use, the application may collect
          information such as your name, contact details, account information,
          student-related information, and other information provided through
          the application.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          2. How We Use Information
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          We use the collected information to provide and maintain our services,
          authenticate users, provide application functionality, communicate
          important updates, improve our services, and maintain the security of
          the application.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          3. Information Sharing
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          We do not sell personal information to third parties. Information may
          be shared with authorized service providers when necessary to provide
          application functionality, comply with legal requirements, or protect
          the security and rights of users.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          4. Data Security
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          We take reasonable technical and organizational measures to protect
          user information from unauthorized access, alteration, disclosure, or
          destruction.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          5. Data Retention
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          Personal information is retained only for as long as necessary to
          provide our services, comply with applicable legal obligations, and
          resolve disputes.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          6. Children's Privacy
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          The application may be used in an educational environment. Any
          information relating to students or children is handled through
          authorized users, parents, guardians, schools, or other authorized
          personnel as applicable.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          7. Third-Party Services
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          The application may use third-party services for hosting,
          authentication, analytics, notifications, payments, or other
          functionality. Such services may process information according to
          their own privacy policies.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          8. Your Rights
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          Depending on applicable laws, you may have rights to access, correct,
          update, or request deletion of your personal information. You may
          contact us using the contact information provided by the organization
          operating the application.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          9. Changes to This Privacy Policy
        </h2>

        <p className="text-gray-700 leading-7 mb-4">
          We may update this Privacy Policy from time to time. Any changes will
          be reflected on this page with an updated effective date.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          10. Contact Us
        </h2>

        <p className="text-gray-700 leading-7">
          If you have questions regarding this Privacy Policy, please contact
          the organization responsible for operating the application.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
